var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlphaCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "551px",
    height: "381px",
    viewBox: "0 0 551 381",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "77.1758805%",
    cy: "25.7379553%",
    fx: "77.1758805%",
    fy: "25.7379553%",
    r: "85.6009838%",
    gradientTransform: "translate(0.771759,0.257380),scale(0.638298,1.000000),rotate(119.826295),translate(-0.771759,-0.257380)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C4CD",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 0,
    width: 470,
    height: 300,
    rx: 20
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-13.2%",
    y: "-22.0%",
    width: "126.4%",
    height: "141.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.103010271 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-12",
    transform: "translate(40.500000, 44.500000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u77E9\\u5F62"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#radialGradient-1)",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M317.05817,238.756047 C296.762603,238.756047 283.063096,224.076156 276.128777,194.549555 L275.283129,194.549555 C258.539286,226.411593 235.030255,242.259203 205.432554,242.259203 C183.276561,242.259203 165.51794,234.085173 152.156692,217.570294 C138.795444,201.055416 132.199385,180.370114 132.199385,155.347571 C132.199385,126.154605 139.810222,102.800231 154.862767,84.6171835 C169.915312,66.4341356 190.380009,57.2592034 216.256856,57.2592034 C230.125493,57.2592034 242.641093,61.0959932 253.465395,68.6027561 C264.289697,76.276336 272.577053,86.9526207 278.327464,100.798428 L279.003982,100.798428 L291.012193,60.7623594 L334.309401,60.7623594 L298.115641,149.508978 C302.174754,170.19428 306.402998,184.373721 311.13863,191.880484 C315.197743,199.387247 320.948153,203.224037 328.051602,203.224037 C332.110715,203.224037 335.32418,202.556769 338.199385,201.38905 L337.861125,235.419709 C330.081158,237.588329 323.14684,238.756047 317.05817,238.756047 Z M266.199385,148.006789 C262.646753,129.147479 256.894874,114.460583 249.112919,104.446789 C241.500137,94.2660996 232.195625,89.2592034 221.537731,89.2592034 C207.66555,89.2592034 196.500137,95.434376 188.210663,107.617824 C179.921189,119.968169 176.199385,135.155755 176.199385,153.013686 C176.199385,169.369548 179.413671,182.888169 186.688107,193.903341 C193.79337,204.918514 203.436227,210.259203 215.447505,210.259203 C225.597881,210.259203 234.902393,205.419204 243.191866,196.239893 C251.650513,186.72679 258.586603,172.874376 264.16931,154.682652 L266.199385,148.006789 L266.199385,148.006789 Z",
    id: "\\u5F62\\u72B6",
    fill: "#000000",
    opacity: 0.102446057
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlphaCard);
export default __webpack_public_path__ + "static/media/alpha-card.969239e87a455360bcd02315faabab78.svg";
export { ForwardRef as ReactComponent };